/**
 * Created by Miguel on 23/05/2017
 */
import { Component, HostListener,OnInit, Input, ViewChild,ChangeDetectionStrategy, ViewEncapsulation,SimpleChanges  } from '@angular/core';
import { ActivatedRoute,RouterLink} from '@angular/router';
import { DomSanitizer,  SafeResourceUrl , SafeHtml } from '@angular/platform-browser';
import { Subscription } from 'rxjs/Subscription';
import {Meta, Title} from "@angular/platform-browser";
import {Router} from "@angular/router";
import { EventBean } from '../../../beansts/Event';

import {FormBuilder, FormGroup} from "@angular/forms";
import { ThrowStmt } from '@angular/compiler';
import { Observable } from 'rxjs';
import { AppDataService }  from '../../../services/app-data.service';
import { CompanyService } from '../../../services';
declare var JitsiMeetExternalAPI;
declare var $ : any;
declare let OT:any;
declare var require: any;
declare let Hls : any;
declare let swal: any;
@Component({
    changeDetection: ChangeDetectionStrategy.Default,
    encapsulation: ViewEncapsulation.Emulated,
    selector : 'teleEventMidia',
    templateUrl:'teleevent-midia-component.html',
    providers  : [],
})
export class TeleEventMidiaComponent implements OnInit {
    public _changed:boolean;
    public api;
    public emojis=[];
    public menu=false;
    public loadingConference=false;
    public conference=false;
    public ngOnInit() : any {
    }
    constructor( public _sanitizer: DomSanitizer,private _companyService: CompanyService,private title: Title, private fb : FormBuilder,public _router : Router,private meta : Meta,private _routeParams : ActivatedRoute,public _appData : AppDataService) {
    }
    public addEmoji(emoji){
      this._companyService.addEmojis(this._appData.event,emoji);

    }
    @Input() set changed(value: boolean) {
      if (!this._changed){
        if (this._appData.event.id){
          this.startVideo();
          this.startEmojis();
          this._changed=true; 
        }
      }
    }
  
    // Alan: Use input property getter
    get changed(): boolean {
      return this.changed;
    }
    public startEmojis(){
          this.toggleMenu(true);
          let ref=this._companyService.getEmojis(this._appData.event);
            ref.on("child_added", (snapshot, prevChildKey) =>{     
                let _emojis=snapshot.val();
                this.emojis.push(_emojis);
                setTimeout(() =>{
                    this.emojis.pop();
                },2000);

            });
       
      }
    public startVideo(){
          if (this._appData.event.hls){
            var video = <HTMLVideoElement>document.getElementById('video');
            var videoSrc = this._appData.event.hls;
            if (Hls.isSupported()) {
              var hls = new Hls();
              hls.loadSource(videoSrc);
              hls.attachMedia(video);
              hls.on(Hls.Events.MANIFEST_PARSED, function() {
                video.style.visibility = "visible";
                video.play();
              });
            }
            else if (video.canPlayType('application/vnd.apple.mpegurl')) {
              video.src = videoSrc;
              video.addEventListener('loadedmetadata', function() {
                video.style.visibility = "visible";
                video.play();
              });
            }
          }      
      }

 
      public toggleMenu(menu){
        this.menu=menu;
      }
}


// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/+gameevent/midia/teleevent-midia-component.ts